<button mat-icon-button [matMenuTriggerFor]="menu" (click)="stopPropagation($event)">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button *ngIf="!isApproved()" mat-menu-item (click)="btnApproveClickedHandler()">
    <span>{{ "RESOURCE_LIST.ADMIN.APPROVE" | translate }}</span>
  </button>
  <button *ngIf="!isBlocked()" mat-menu-item (click)="btnDisableClickedHandler()">
    <span>{{ "RESOURCE_LIST.ADMIN.BLOCK" | translate }}</span>
  </button>
  <button *ngIf="isPending()" mat-menu-item (click)="btnDeleteClickedHandler()">
    <span>{{ "RESOURCE_LIST.ADMIN.DELETE" | translate }}</span>
  </button>
  <button *ngIf="!isAdminMark; else removeAdmin" mat-menu-item (click)="btnMakeAdminClickedHandler()">
    <span>{{ "RESOURCE_LIST.ADMIN.MAKE_ADMIN" | translate }}</span>
  </button>
  <ng-template #removeAdmin>
    <button mat-menu-item (click)="btnRemoveAdminClickedHandler()">
      <span>{{ "RESOURCE_LIST.ADMIN.REMOVE_ADMIN" | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
